"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Button, Icon, Typography } from "@bookips/sds";
import { useState } from "react";
/** 개별 필터 드롭다운 */ const FilterDropdown = (param)=>{
    let { filter , onSelect  } = param;
    const [isOpen, setIsOpen] = useState(false);
    const selectedOption = filter.options.find((opt)=>opt.value === filter.selectedValue);
    const displayLabel = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || filter.label;
    const handleSelect = (value)=>{
        onSelect(value);
        setIsOpen(false);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ _jsx(Button, {
                variant: "stroke",
                color: "secondary",
                size: "sm",
                onClick: ()=>setIsOpen(!isOpen),
                rightElement: /*#__PURE__*/ _jsx(Icon.Triangle, {
                    className: cn("size-4 text-gray-500 transition-transform", isOpen && "rotate-180")
                }),
                className: cn("min-w-[80px]", filter.selectedValue && filter.selectedValue !== "all" && "border-primary-main"),
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "body2",
                    className: cn(filter.selectedValue && filter.selectedValue !== "all" ? "text-primary-main" : "text-primary"),
                    children: displayLabel
                })
            }),
            isOpen && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "fixed inset-0 z-10",
                        onClick: ()=>setIsOpen(false)
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "absolute left-0 top-full z-20 mt-1 min-w-[120px] rounded-md border border-gray-200 bg-white py-1 shadow-lg",
                        children: [
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                onClick: ()=>handleSelect("all"),
                                className: cn("w-full px-3 py-2 text-left hover:bg-gray-50", (!filter.selectedValue || filter.selectedValue === "all") && "bg-gray-50"),
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body2",
                                    className: cn(!filter.selectedValue || filter.selectedValue === "all" ? "text-primary-main" : "text-primary"),
                                    children: "전체"
                                })
                            }),
                            filter.options.map((option)=>/*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    onClick: ()=>handleSelect(option.value),
                                    className: cn("w-full px-3 py-2 text-left hover:bg-gray-50", option.value === filter.selectedValue && "bg-gray-50"),
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "body2",
                                        className: cn(option.value === filter.selectedValue ? "text-primary-main" : "text-primary"),
                                        children: option.label
                                    })
                                }, option.value))
                        ]
                    })
                ]
            })
        ]
    });
};
/**
 * 필터 바 컴포넌트 (마지막 depth 전용)
 * - 단원 필터
 * - 자료유형 필터
 */ export const FilterBar = (param)=>{
    let { className , filters , onFilterChange  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn("flex flex-wrap items-center gap-2 py-2", className),
        children: filters.map((filter)=>{
            /*#__PURE__*/ return _jsx(FilterDropdown, {
                filter: filter,
                onSelect: (value)=>{
                    return onFilterChange === null || onFilterChange === void 0 ? void 0 : onFilterChange(filter.id, value);
                }
            }, filter.id);
        })
    });
};
